// extracted by mini-css-extract-plugin
export var acceptButton = "_17-5";
export var fullContent = "_17-4";
export var link = "_17-6";
export var linkIcon = "_17-7";
export var sideContent = "_17-3";
export var sideImage = "_17-2";
export var sideImageWrapper = "_17-1";
export var splitLayout = "_17-0";